export default __webpack_public_path__ + "static/media/PlusWhite.6de62299.svg";